<template>
    <div class="map-marker">
        <!-- :selectFeature="select"  -->
        <LVector v-if="gList.length > 0" :zIndex="20" :selectFeature="select">
            <template v-for="item in gList">
                <LPolygonFeature
                    :key="item.id"
                    :positions="[item.points]"
                    :obj="item"
                    :id="item.id"
                    :defaultStyle="{
                        fill: {
                            color:
                                item.id === hoverId
                                    ? hoverColor
                                    : item.executeStatus === 1
                                    ? '#FF0D4750'
                                    : '#8FFF0020',
                            borderColor: '#FF515B',
                        },
                        stroke: {
                            color: '#000', // 边框颜色
                            width: 1, // 边框宽度
                        },
                    }"
                />

                <LPointFeature
                    v-if="item.routeId !== '-1' && hasAirLine"
                    :key="item.id + 'Point'"
                    :id="item.id"
                    :obj="item"
                    :longitude="item.points[1][0]"
                    :latitude="item.points[1][1]"
                    :defaultStyle="pointStyle(item)"
                />
            </template>
        </LVector>
        <!-- 机库弹窗 -->
        <el-popover
            placement="top"
            width="218px"
            trigger="click"
            v-model="visible"
            popper-class="is-no-padding is-no-arrow"
        >
            <div class="c-hive-point__popover">
                <div class="c-hive-point__main">
                    <div class="c-hive-point__item" v-if="gridObj.gridCode">
                        <div class="c-hive-point__label">{{ $t('gridManage.gridCode') }}</div>
                        <div class="c-hive-point__value">{{ gridObj.gridCode || '' }}</div>
                    </div>
                    <div class="c-hive-point__item" v-if="gridObj.name">
                        <div class="c-hive-point__label">{{ $t('gridManage.gridName') }}</div>
                        <div class="c-hive-point__value">{{ gridObj.name || '' }}</div>
                    </div>
                    <div class="c-hive-point__item" v-if="gridObj.altitude">
                        <div class="c-hive-point__label">{{ $t('gridManage.maxAltitudeM') }}</div>
                        <div class="c-hive-point__value">{{ gridObj.altitude || '' }}</div>
                    </div>
                    <div class="c-hive-point__item" v-if="gridObj.executeStatus !== undefined">
                        <div class="c-hive-point__label">{{ $t('gridManage.status') }}</div>
                        <div
                            class="c-hive-point__value"
                            :class="gridObj.executeStatus === 1 ? 'red ' : 'green'"
                        >
                            {{ gridObj.executeStatus === 1 ? $t('gridManage.noFly') : $t('gridManage.flyable') }}
                        </div>
                    </div>
                </div>
                <!--  @click="toDetailView(hiveObj)" -->
                <template v-if="gridObj.executeStatus !== 1">
                    <div class="c-hive-point__btn" @click="ToGridRoute(gridObj)">
                        {{ gridObj.routeId === '-1' ? $t('gridManage.generateRoute') : $t('gridManage.viewRoute') }}
                    </div>
                    <div class="c-hive-point__btn" v-if="gridObj.hiveId" @click="ToGridConsole(gridObj)">
                        {{ $t('gridManage.enterLive') }}
                    </div>
                    <div class="c-hive-point__btn" v-if="gridObj.zkTaskId" @click="ToGridTask(gridObj)">
                        {{ $t('gridManage.gridTask') }}
                    </div>
                </template>
            </div>
            <div slot="reference" :style="style"></div>
        </el-popover>
    </div>
</template>
<script>
import { FullScreen } from '@CommonComponent';
import { LCircleFeature, OMapMixin, LVector, LPointFeature, LPolygonFeature } from '@OpenLayersCommon';
import { StringUtil } from '@Util';
import { pbkdf2 } from 'crypto';
// import imgs from './imgs';

export default {
    mixins: [OMapMixin],

    props: {
        gridList: Array,
        TaskInRunTimeList: Array,
        clickable: {
            default: true,
        },
        hasAirLine: Boolean,
        selectId: String,
        selectFn: Function,
    },
    // layer-polygon-feature
    // Marker ,LPoints LMarker, LCircularRange,Video, FullScreen,LCircleFeature
    components: { LVector, LPolygonFeature, LPointFeature },
    data() {
        return {
            visible: false,
            gList: [],
            mapZoom: 13,
            hoverColor: '',
            hoverId: '',
            gridObj: {},
            style: {
                position: 'absolute',
                top: '100px',
                left: '100px',
            },
            TaskInRunTime: null,
            TaskList: [],
        };
    },
    watch: {
        selectId: {
            handler() {
                let index = 0;
                let newIndex = this.gList.findIndex((item) => item.id === this.selectId);
                if (newIndex !== -1) {
                    index = newIndex;
                }
                this.hoverId = this.gList[index].id;
                this.hoverColor = this.gList[index].executeStatus === 1 ? '#FF0D4790' : '#8FFF0090';
            },
        },

        gridList: {
            handler(newVal, oldVal) {
                this.gList = newVal;
                this.hoverId = this.gList[0].id;
                this.hoverColor = this.gList[0].executeStatus === 1 ? '#FF0D4790' : '#8FFF0090';
            },
            immediate: true,
            deep: true,
        },
        TaskInRunTimeList: {
            handler(newVal, oldVal) {
                this.TaskList = newVal || [];
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {},

    async mounted() {
        let map = await this.getMap();
        this.map = map;
        // this.layerAuto = this.getLayerAuto();
        // 更新zoom
        this.map.getView().on('change:resolution', this.changeZoom);
    },

    beforeDestroy() {
        this.map && this.map.getView().un('change:resolution', this.changeZoom);
    },

    methods: {
        getLayerAuto() {
            let LayerAuto = {
                hasBhangar: true,
                hasArea: true,
                hasOther: true,
                ...this.$store.state.Common.LayerAuto,
            };

            return LayerAuto;
        },

        // 双击全屏
        dblclick() {
            this.handleFullScreen();
        },

        handleFullScreen() {
            this.$refs.fullscreen.toggleFullCreeen();
        },

        select(e, id, feature, obj) {
            this.visible = false;
            if (id) {
                console.log(obj, '=============');
                this.selectFn(obj, false);

                let Taskobj = this.TaskList.length > 0 ? this.TaskList.find((it) => it.gridId === obj.id) : null;
                this.gridObj = {
                    ...obj,
                    // uavId: Taskobj.uavId || null,
                    // hiveId: Taskobj.hiveId || null,
                };
                this.hoverId = id;
                let [x, y] = e.pixel_;
                this.style.top = `${y}px`;
                this.style.left = `${x}px`;
                setTimeout(() => {
                    this.showPopover(id);
                }, 50);
                this.hoverColor = obj.executeStatus === 1 ? '#FF0D4790' : '#8FFF0090';
            } else {
                this.hoverId = '';
            }
        },

        pointStyle(item) {
            let mapZoom = this.mapZoom;
            let scale = (mapZoom - 13) * 0.2 + 0.25;
            if (scale < 0.6) scale = 0.4;
            if (scale > 1) scale = 1;
            let obj = {
                icon: {
                    src: require('./imgs/icon_col-1.png'),
                    scale,
                    anchor: [-0.01, -0.01],
                },
                text: {},
            };
            return obj;
        },

        // 显示弹窗
        showPopover(id) {
            this.$nextTick(() => {
                this.visible = true;
            });
        },

        ToGridRoute(obj) {
            const href = this.$router.resolve({
                path: '/gridRouteMap',
                query: {
                    type: obj.routeId === '-1' ? 'add' : 'see',
                    gridId: obj.id,
                    altitude: obj.altitude,
                },
            }).href;
            window.open(href, '_blank');
        },
        ToGridConsole(obj) {
            this.$router.push({
                path: '/console',
                query: {
                    type: 2,
                    hiveCode: obj.id,
                    uavCode: obj.altitude,
                },
            });
        },

        ToGridTask(obj) {
            let val = `?organId=9f142bf13f3d42828efd8fefb9f29a4a&typeId=02d0bc6a618f4d7e856e936eeb72bbb1&itemId=22c63bed50d7477bb88a09c50762fc04&gridId=${
                obj.id
            }&routeId=${obj.routeId}&gridName=${obj.name}&defaultSiteId=${obj.defaultSiteId}&siteName=${
                obj.siteName || ''
            }`;
            console.log('ToGridTask', `${window.gconfig.SERVER}/manage/task/grid/toList${val}`);
            // window.location.href = `${window.gconfig.SERVER}/manage/task/grid/toList${val}`;
            // eslint-disable-next-line no-restricted-globals
            parent.Fastf.getTab().openSimplePageInNewTab(
                this.$t('gridManage.gridTaskWithName', { name: obj.name }),
                `${window.gconfig.SERVER}/manage/task/grid/toList${val}`,
            );
        },

        changeZoom(evt) {
            const zoom = this.map.getView().getZoom(); // 获取当前地图的缩放级别
            this.mapZoom = zoom;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

@include b(hive-point, c) {
    @include e(popover) {
        position: relative;
        width: 212px;
        padding: 16px;
        box-sizing: border-box;
        &::after {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -2;
            position: absolute;
            top: -0px;
            left: 0px;
            background-color: #071150;
        }
        &::before {
            content: '';
            display: block;
            width: 100%;
            height: 100%;
            z-index: -1;
            position: absolute;
            top: 0px;
            left: 0px;
            border: 24px solid;
            box-sizing: border-box;
            border-image: url(./imgs/bg_wrap.png) 24 24;
        }
        @include e(header) {
            display: inline-block;
            text-align: center;
            width: 100%;
            height: 30px;
            background-color: rgba(255, 226, 184, 0.2);
            border-radius: 3px;
            outline: thick double rgba(255, 226, 184, 0.2);
            line-height: 30px;
            font-weight: 400;
            color: #ffe600;
            font-size: 16px;
        }
        @include e(main) {
            // width: 200px;
            color: white;
            @include e(item) {
                display: flex;
                // margin-bottom: 4px;
                line-height: 26px;
                @include e(label) {
                    //    max-width: 154px;
                    height: 26px;
                    padding: 2px;
                    // background: linear-gradient(91deg, #50f5ff 0%, rgba(80, 245, 255, 0) 100%);
                    // vertical-align: middle;
                    text-align: left;
                }
                @include e(value) {
                    margin-left: 16px;
                    padding: 2px;
                    display: flex;
                    // width: calc(100% - 74px - 16px);
                    overflow: hidden;
                    color: #49f0fd;
                    // width: 180px;
                    .progress {
                        width: 150px;
                        &::v-deep .el-progress__text {
                            font-size: 16px !important;
                            color: #49f0fd !important;
                        }
                    }
                    .value-img {
                        width: 20px;
                        height: 26px;
                    }
                    ::v-deep.el-progress-bar__outer,
                    ::v-deep.el-progress-bar__inner {
                        border-radius: 0;
                    }

                    ::v-deep.el-progress-bar__inner {
                        background: linear-gradient(270deg, #36eaaf 0%, #4bb3d2 100%);
                    }
                    ::v-deep.el-progress-bar__outer {
                        background: rgba(255, 255, 255, 0.1);
                    }
                }
            }
        }
        @include e(btn) {
            width: 100%;
            height: 30px;
            line-height: 30px;
            background: rgba(73, 240, 253, 0.2);
            border: 1px solid #49f0fd;
            display: inline-block;
            font-weight: 400;
            color: #49f0fd;
            font-size: 14px;
            margin-top: 8px;
            cursor: pointer;
            text-align: center;
        }
    }
}
.green {
    color: #62ecba;
}
.red {
    color: #ff0d47;
}
.col-green {
    color: #62ecba;
}
</style>
